export const getMountainDate = (offsetDays = 0) => {
    const d = new Date();
    d.setDate(d.getDate() + offsetDays);
    const mountainTime = new Intl.DateTimeFormat("en-US", {
        timeZone: "America/Denver",
        year: "numeric", month: "2-digit", day: "2-digit"
    }).format(d);
    const [month, day, year] = mountainTime.split("/");
    return `${year}-${month}-${day}`;
};

const METERS_PER_MILE = 1609.34;
const METERS_PER_YARD = 0.9144;

const normalizeSportType = (sport) => {
    if (sport === "VirtualRun") return "Run";
    if (sport === "VirtualRide" || sport === "EBikeRide") return "Ride";
    return sport;
};

const formatDuration = (seconds) => {
    if (!seconds) return "—";
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = Math.round(seconds % 60);
    if (h > 0) return `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
    return `${m}:${String(s).padStart(2, "0")}`;
};

const formatActivityLine = (a) => {
    const sport = normalizeSportType(a.sport_type || a.type || "Activity");
    const miles = (a.distance || 0) / METERS_PER_MILE;
    const duration = formatDuration(a.moving_time);

    let distanceStr;
    let paceStr = "";
    if (sport === "Swim") {
        const yards = (a.distance || 0) / METERS_PER_YARD;
        distanceStr = `${Math.round(yards)}yd`;
    } else {
        distanceStr = `${miles.toFixed(1)}mi`;
        if (sport === "Run" && miles > 0) {
            const paceSecs = a.moving_time / miles;
            paceStr = ` (${formatDuration(paceSecs)}/mi)`;
        } else if (sport === "Ride" && a.moving_time > 0) {
            const mph = miles / (a.moving_time / 3600);
            const power = a.average_watts ? `, ${Math.round(a.average_watts)}W avg` : "";
            paceStr = ` (${mph.toFixed(1)}mph${power})`;
        }
    }

    return `${sport} ${distanceStr} in ${duration}${paceStr}`;
};

export const formatWorkoutText = (workout, date, activities = []) => {
    const description = (workout && (workout.planName || workout.description)) || "";
    const weekday = new Intl.DateTimeFormat("en-US", {
        timeZone: "America/Denver",
        weekday: "long"
    }).format(new Date(`${date || getMountainDate()}T12:00:00`));

    const lines = [`${description} - ${weekday}`.trim()];

    if (activities.length > 0) {
        lines.push("");
        activities.forEach(a => lines.push(`• ${formatActivityLine(a)}`));
    }

    return lines.join("\n").trim();
};
